import UserAccountsModule from './index.vue';

// eslint-disable-next-line import/prefer-default-export
export const userAccountRoutes = [
  {
    path: '/new-user',
    name: 'NewUser',
    component: () => import(/* webpackChunkName: "users" */ './pages/new-user.vue'),
    meta: { // ToDo:This should be added to the DB as it can be managed through admins?
      showForAllLoggedUsers: true,
      showForGuestUsers: false,
    },
  },
  {
    path: '/users',
    component: UserAccountsModule,
    meta: {
      /** Access to this route is managed on the server no need to specify in the meta */
    },
    children: [
      {
        path: '',
        name: 'Users',
        component: () => import(/* webpackChunkName: "users" */ './pages/user-list.vue'),
        meta: {
          requiresAuth: true,
        },
        beforeEnter(to, from, next) {
          // TODO: validate if user admin
          // console.log(to, from);
          next();
        },
      },
      // {
      //   path: ':id',
      //   name: 'Profile',
      //   component: () => import(/* webpackChunkName: "users" */ './pages/user-profile.vue'),
      //   meta: {
      //     requiresAuth: true,
      //   },
      //   beforeEnter(to, from, next) {
      //     // TODO: validate if user id matches logged user id if user is not admin
      //     console.log(to, from);
      //     next();
      //   },
      // },
      {
        path: '/manage-scc-user/:id',
        name: 'ManageSCCUser',
        component: () => import(/* webpackChunkName: "users" */ './pages/manage-scc-user.vue'),
        meta: { // ToDo:This should be added to the DB as it can be managed through admins?
          showForAllLoggedUsers: true,
          showForGuestUsers: false,
        },
      },
      {
        path: '/scc-user-profile/:id',
        name: 'SCCUserProfile',
        component: () => import(/* webpackChunkName: "users" */ './pages/scc-user-profile.vue'),
        meta: {
          /** Access to this route is managed on the server no need to specify in the meta */
        },
      },
      {
        path: '/manage-web-info/:id',
        name: 'ManageWebLoginInfo',
        component: () => import(/* webpackChunkName: "users" */ './pages/manage-web-info.vue'),
        meta: { // ToDo:This should be added to the DB as it can be managed through admins?
          showForAllLoggedUsers: true,
          showForGuestUsers: false,
        },
      },
    ],
  },
  {
    path: '/update-password/',
    name: 'UpdatePassword',
    component: () => import(/* webpackChunkName: "users" */ './pages/update-password.vue'),
    meta: {
      /** Access to this route is managed on the server no need to specify in the meta */
    },
  },
  {
    path: '/scc-user-list',
    name: 'SCCUserList',
    component: () => import(/* webpackChunkName: "users" */ './pages/scc-user-list.vue'),
    meta: {
      /** Access to this route is managed on the server no need to specify in the meta */
    },
  },
  {
    path: '/web-user-list',
    name: 'WebUserList',
    component: () => import(/* webpackChunkName: "users" */ './pages/web-user-list.vue'),
    meta: {
      /** Access to this route is managed on the server no need to specify in the meta */
    },
  },
  {
    path: '/manage-customer/:id',
    name: 'ManageCustomer',
    component: () => import(/* webpackChunkName: "users" */ './pages/manage-customer.vue'),
    meta: {
      /** Access to this route is managed on the server no need to specify in the meta */
    },
  },
];
